const _excluded = ["className", "tabs"];
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], t.indexOf(o) >= 0 || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.indexOf(n) >= 0) continue; t[n] = r[n]; } return t; }
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == typeof i ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != typeof t || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != typeof i) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
import React from 'react';
import { Tabs as MuiTabs, Tab, makeStyles } from '@material-ui/core';
import colors from "../../foundations/colors.module.scss";
import typography from "../../foundations/typography.module.scss";
import { jsx as _jsx } from "react/jsx-runtime";
const typographyStyles = {
  fontFamily: typography.fontFamilyLight,
  lineHeight: typography.lineHeightP1,
  color: colors.dark700
};
const sharedBorderStyles = {
  content: '""',
  position: 'absolute',
  bottom: 0,
  width: '100%'
};
const useTabContainerStyles = makeStyles(() => ({
  root: _objectSpread({}, typographyStyles),
  flexContainer: {
    gap: 48,
    '&::after': _objectSpread(_objectSpread({}, sharedBorderStyles), {}, {
      backgroundColor: colors.dark200,
      height: '2px'
    })
  },
  indicator: {
    backgroundColor: 'transparent'
  }
}));
const useSingleTabStyles = makeStyles(() => ({
  root: _objectSpread(_objectSpread({}, typographyStyles), {}, {
    textTransform: 'none',
    padding: 0,
    minWidth: 0,
    '&::after': _objectSpread(_objectSpread({}, sharedBorderStyles), {}, {
      backgroundColor: 'transparent',
      borderTopLeftRadius: 1.5,
      borderTopRightRadius: 1.5,
      height: '4px',
      transition: 'background-color 0.2s ease 0s',
      zIndex: 1
    }),
    '&:hover:not([aria-selected=true])': {
      color: colors.dark900
    },
    overflow: 'unset',
    opacity: 1
  }),
  selected: {
    '&::after': {
      backgroundColor: colors.purple800
    }
  }
}));
export function Tabs(_ref) {
  let {
      className,
      tabs
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  const tabsStyles = useTabContainerStyles();
  const tabStyles = useSingleTabStyles();
  return /*#__PURE__*/_jsx("div", {
    className: className,
    "data-testid": props['data-testid'],
    children: /*#__PURE__*/_jsx(MuiTabs, _objectSpread(_objectSpread({
      classes: tabsStyles,
      "aria-label": props['aria-label']
    }, props), {}, {
      children: tabs.map(_ref2 => {
        let {
          component,
          id,
          value,
          disabled,
          testId
        } = _ref2;
        return /*#__PURE__*/_jsx(Tab, {
          classes: tabStyles,
          disableRipple: true,
          focusVisibleClassName: "focusVisible",
          label: component,
          value: value,
          disabled: disabled,
          "data-testid": testId
        }, id);
      })
    }))
  });
}